// ----------------------------------------------------------------------

import { AxiosError } from 'axios';

export function getErrorMessage(error: unknown): string {
  if (error instanceof AxiosError) {
    return error.response?.data?.error?.message;
  } else {
    if (error instanceof Error) {
      return error.message || error.name || 'An error occurred';
    }

    if (typeof error === 'string') {
      return error;
    }

    if (typeof error === 'object' && error !== null) {
      const errorMessage = (error as { message?: string }).message;
      if (typeof errorMessage === 'string') {
        return errorMessage;
      }
    }

    return `Unknown error: ${error}`;
  }
}
